import global from '../../../config/global';

const baseURL = global.apisUrl + '/cnp';

export const energyAssetsURL = (id) => baseURL + `/assets${id ? '/' + id : ''}`;

export const carbonEmissionProfileURL = baseURL + `/carbon-emission-profile`;
export const capexURL = baseURL + `/capex`;
export const opexURL = baseURL + `/opex`;

export const npvURL = (id) => baseURL + `/npv${id ? '/' + id : ''}`;
export const lcoeURL = (id) => baseURL + `/lcoe${id ? '/' + id : ''}`;

export const getAllCNPReports = baseURL + `/get-all-CNP-templates`;

export const getCNPReportURL = (type, id) => baseURL + `/report/${type}/${id}`;

export const createCustomReportURL = baseURL + '/create-custom-report';
export const updateCustomReportURL = baseURL + '/update-custom-report';
export const deleteCustomReportURL = (id) => baseURL + `/delete-custom-report/${id}`;

export const mitigationURL = baseURL + `/mitigation`;

export const uploadCKEditorTempImageURL = baseURL + '/upload-ckeditor-temp-image';

export const cleanCKEditorTempImages = baseURL + '/clean-ckeditor-temp-images';
